<template>
  <div :class="{'container-ingressos': desktop, 'w-100': mobile}">
    <p class="text-h6 primary--text pa-5 mb-0">
      Ingressos disponiveis
    </p>

    <div class="scroll-ingressos">
      <div
        v-for="(ingresso, i) in ingressos"
        :key="ingresso.id"
        class="tab-ingresso d-flex flex-row justify-space-between px-5 py-2"
        :class="{'active': ingressoAtual == ingresso.id}"
        @click="selecionaIngresso(ingresso)"
      >
        <div class="label-ingresso">
          {{ ingresso.name != '' ? ingresso.name : 'Ingresso ' + (i + 1) }}
        </div>

        <v-chip :color="ingresso.name != '' ? 'green' : 'blue'" class="white--text">
          {{ ingresso.name != '' ? 'Dados preenchidos' : 'Vazio' }}
        </v-chip>
      </div>
    </div>

    <v-btn
      v-if="mobile"
      class="mt-2 my-5"
      color="primary"
      text
      block
      @click="$emit('change', ingressoAtual)"
    >
      Prosseguir <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'TitularidadeIngressoTabs',

  props: {
    ingressos: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    ingressoAtual: null,
  }),

  watch: {
    ingressoAtual(value) {
      if (this.desktop) {
        this.$emit('change', value);
      }
    },
  },

  async mounted() {
    if (this.desktop) {
      let ingressoASelecionar = this.ingressos.find(ingresso => ingresso.name === '');

      if (!ingressoASelecionar) {
        ingressoASelecionar = this.ingressos.find(
          ingresso => ingresso.remaining_changes > 0,
        );
      }

      this.selecionaIngresso(ingressoASelecionar || this.ingressos[0]);

      this.$nextTick(() => {
        document.querySelector('.tab-ingresso.active').scrollIntoView();
      });
    }
  },

  methods: {
    selecionaIngresso(ingresso) {
      this.ingressoAtual = ingresso.id;
    },
  },
};
</script>

<style scoped>
.container-ingressos {
  width: 420px;
  border-right: solid #D3D4D3 1px;
}

.scroll-ingressos {
  max-height: 408px;
  overflow-y: auto;
}

.tab-ingresso {
  background-color: #FFF;
  width: 100%;
  text-transform: none;
  border-bottom: solid #D3D4D3 1px;
  border-top: solid #D3D4D3 1px;
  cursor: pointer;
}

.tab-ingresso:not(.active, .inactive):hover {
  background-color: #F0F0FF;
}

.tab-ingresso ~ .tab-ingresso {
  border-top: none;
}

.tab-ingresso.active {
  background-color: #DDF;
  font-weight: bold;
  cursor: default;
}

.label-ingresso {
  max-width: 138px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
